import { render } from "./CrmSaas.vue?vue&type=template&id=731d13b5&scoped=true"
import script from "./CrmSaas.vue?vue&type=script&lang=js"
export * from "./CrmSaas.vue?vue&type=script&lang=js"

import "./CrmSaas.vue?vue&type=style&index=0&id=731d13b5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731d13b5"]])

export default __exports__